export function usePageMeta({
  title,
  description = '',
  isPublicPage = false,
}: {
  title: string
  description?: string | (() => string)
  isPublicPage?: boolean
}) {
  useHead({
    title,
  })

  if (isPublicPage) {
    useSeoMeta({
      title,
      description,
      ogTitle: title,
      ogDescription: description,
      twitterTitle: title,
      twitterDescription: description,
    })
  }
}
